import { audioTrackFeature } from "./audio-track.js";
import { bufferFeature } from "./buffer.js";
import { controlsFeature } from "./controls.js";
import { errorFeature } from "./error.js";
import { fullscreenFeature } from "./fullscreen.js";
import { liveFeature } from "./live.js";
import { metadataFeature } from "./metadata.js";
import { pipFeature } from "./pip.js";
import { playbackFeature } from "./playback.js";
import { playbackRateFeature } from "./playback-rate.js";
import { qualityFeature } from "./quality.js";
import { remotePlaybackFeature } from "./remote-playback.js";
import { sourceFeature } from "./source.js";
import { textTrackFeature } from "./text-track.js";
import { timeFeature } from "./time.js";
import { volumeFeature } from "./volume.js";
//#region src/dom/store/features/presets.ts
const videoFeatures = [
	playbackFeature,
	playbackRateFeature,
	qualityFeature,
	audioTrackFeature,
	volumeFeature,
	timeFeature,
	sourceFeature,
	bufferFeature,
	fullscreenFeature,
	pipFeature,
	remotePlaybackFeature,
	controlsFeature,
	textTrackFeature,
	errorFeature,
	metadataFeature
];
const audioFeatures = [
	playbackFeature,
	playbackRateFeature,
	volumeFeature,
	timeFeature,
	sourceFeature,
	bufferFeature,
	errorFeature,
	metadataFeature
];
const backgroundFeatures = [];
/**
* Features for a live video player. Mirrors {@link videoFeatures} but drops {@link playbackRateFeature} (not meaningful
* for live) along with {@link qualityFeature} and {@link audioTrackFeature}, and adds {@link liveFeature} so store
* consumers can read `liveEdgeStart` and `targetLiveWindow`.
*/
const liveVideoFeatures = [
	playbackFeature,
	volumeFeature,
	timeFeature,
	sourceFeature,
	bufferFeature,
	fullscreenFeature,
	pipFeature,
	remotePlaybackFeature,
	controlsFeature,
	textTrackFeature,
	errorFeature,
	liveFeature,
	metadataFeature
];
/**
* Features for a live audio player. Mirrors {@link audioFeatures} but drops {@link playbackRateFeature} (not meaningful
* for live) and adds {@link liveFeature} so store consumers can read `liveEdgeStart` and `targetLiveWindow`.
*/
const liveAudioFeatures = [
	playbackFeature,
	volumeFeature,
	timeFeature,
	sourceFeature,
	bufferFeature,
	errorFeature,
	liveFeature,
	metadataFeature
];
//#endregion
export { audioFeatures, backgroundFeatures, liveAudioFeatures, liveVideoFeatures, videoFeatures };

//# sourceMappingURL=presets.js.map